import axios from "axios";
import { api } from "./helper";
import store from "../../store/store"
import { v4 as uuidv4 } from 'uuid';

function prepareDataRequest(data) {
  return {
    RequestCorrelationId: uuidv4(),
    Data: data
  };
}

export function prepareRequest(data) {
  return {
    ...data,
    RequestCorrelationId: uuidv4()
  };
}

const client = axios.create({
    baseURL: api,
    withCredentials: false,
});

client.interceptors.request.use((config) => {
    config.headers.Authorization = "Bearer " + store.state.user.jwt;
    return config;
});

function CreateSubrogationStatusNote(note) {
  return client.post("Common/InsertSubrogationStatusNote", prepareDataRequest(note));
}

function DeleteSubrogationStatusNote(note) {
  return client.post(
    "Common/DeleteSubrogationStatusNote",
    prepareDataRequest({ id: note.id, commandUserId: note.uid })
  );
}

function UpdateSubrogationStatusNote(note) {
    var item = { id: note.id, status: note.status, commandUserId: note.uid };
    return client.post("Common/UpdateSubrogationStatusNote", prepareRequest(item));
}

function GetSubrogationStatuses(subrogationId) {
  return client.post(
    "Common/GetSubrogationStatuses",
    prepareRequest({ SubrogationId: subrogationId })
  );
}

function GetStatusNotes(subrogationStatusId) {
  return client.post(
    "Common/GetStatusNotes",
    prepareRequest({ SubrogationStatusId: subrogationStatusId })
  );
}


export {
    CreateSubrogationStatusNote,
    DeleteSubrogationStatusNote,
    UpdateSubrogationStatusNote,
    GetSubrogationStatuses,
    GetStatusNotes
}